import React from 'react';
import PropTypes from 'prop-types';
import { Rnd } from 'react-rnd';
import { FiX, FiGithub } from 'react-icons/fi';
import { AiOutlineLink } from 'react-icons/ai';

const ProjectModal = ({ project, onClose }) => {
  if (!project) return null;

  return (
    <Rnd
      default={{
        x: 280,
        y: 80,
        width: '300px',
        height: 'auto',
      }}
      minWidth={300}
      minHeight={200}
      dragHandleClassName="modal-drag-handle"
      className=" z-50"
    >
      <div className="bg-gray-900 text-white p-4 rounded-lg shadow-lg">
        <div className="flex justify-between items-center mb-4 modal-drag-handle cursor-move">
          <h2 className="text-lg">{project.name}</h2>
          <button className="text-white" onClick={onClose}>
            <FiX />
          </button>
        </div>
        <div className="overflow-y-auto max-h-80vh">
          <div className="p-4">
            <img src={project.image} alt={project.name} className="rounded-lg mb-4" style={{ maxWidth: '100%' }} />
            <p className="mb-4">{project.desc}</p>
            <div className='flex flex-row gap-4'>
              { project.link && <div className="flex items-center ">
                <a href={project.link} className="hover:underline" target="_blank" rel="noopener noreferrer">
                  <AiOutlineLink className="mr-2" />
                </a>
              </div> }
              { project.githubLink && <div className="flex items-center">
                <a href={project.githubLink} className="hover:underline" target="_blank" rel="noopener noreferrer">
                  <FiGithub className="mr-2" />
                </a>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </Rnd>
  );
};

ProjectModal.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    githubLink: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
};

export default ProjectModal;
